var _style, _circle, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#D80027;}\n\t.st4{fill:#000000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487.5,146.6c-13-27.5-30.8-52.3-52.2-73.3L256,55.7L76.7,73.3c-0.6,0.6-1.1,1.1-1.7,1.7l71.6,71.6l109.4,3.3 L487.5,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,437c0.9,0.9,1.9,1.9,2.8,2.8L256,456.3l178.2-16.5c21.7-21,39.6-45.8,52.8-73.3l-331.2-10.3 C127.3,384.7,94.5,417.5,75,437L75,437z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M509.5,219.9l-298-8.4L256,256c-13.2,13.2-32.9,32.9-44.5,44.5l297.8-7.3c1.8-12.1,2.7-24.6,2.7-37.2 C512,243.7,511.1,231.7,509.5,219.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,0C186.2,0,122.9,28,76.7,73.3h358.6C389.1,28,325.8,0,256,0L256,0z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.9,219.9h289.5c-3.7-25.9-11.2-50.5-22-73.3H146.6L219.9,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.5,366.5H487c10.9-22.8,18.5-47.4,22.3-73.3H218.8C190.4,321.6,166.3,345.7,145.5,366.5L145.5,366.5z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,512c69.3,0,132.1-27.5,178.2-72.2H77.8C123.9,484.5,186.7,512,256,512z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.4,59.9c-5.7,4.8-11.2,9.8-16.4,15l181,181L75,437c5.3,5.3,10.7,10.3,16.4,15L287.5,256L91.4,59.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.9,189.2l16.6,51h53.6l-43.4,31.5l16.6,51l-43.4-31.5l-43.4,31.5l16.6-51l-43.4-31.5h53.6L102.9,189.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.5,260.2l-43.2-15.3c0,0-3.2-29.9-3.4-31c-1.5-7.7-8.3-13.6-16.4-13.6c-9.2,0-16.7,7.5-16.7,16.7 c0,1.5,0.2,3,0.6,4.4l-12.1,12.2h21.5c0,22.4-16.7,22.4-16.7,44.6l9.3,22.3h55.7l9.3-22.3h0c0.9-2.1,1.5-4.3,1.7-6.5 C146.1,268.5,148.5,260.2,148.5,260.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/zw.2721fe180272140ef4230f10cb979a0b.svg";
export { ForwardRef as ReactComponent };